import { useState } from "react";
import axios from "axios";
import { Mail, ArrowRight, Loader2, Check } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      await axios.post(`${API}/newsletter`, { email });
      setStatus("success");
      toast.success("Inscription confirmée. Merci !");
      setEmail("");
    } catch (err) {
      console.error(err);
      setStatus("idle");
      toast.error("Email invalide ou erreur serveur.");
    }
  };

  return (
    <form onSubmit={onSubmit} className="mt-5" data-testid="newsletter-form">
      <div className="text-[10px] font-bold tracking-[0.2em] uppercase text-brand-blue mb-3">Newsletter IA</div>
      <p className="text-sm text-slate-300 mb-3 leading-relaxed">1 email/mois : nouveaux outils IA, prompts utiles, sessions à venir. Zéro spam.</p>
      {status === "success" ? (
        <div className="flex items-center gap-2 text-sm text-brand-cta font-semibold" data-testid="newsletter-success">
          <Check className="w-4 h-4" /> Inscription confirmée
        </div>
      ) : (
        <div className="flex border border-white/20 focus-within:border-white transition-colors">
          <div className="pl-3 flex items-center text-slate-500">
            <Mail className="w-4 h-4" />
          </div>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="vous@entreprise.fr"
            data-testid="newsletter-input"
            className="flex-1 bg-transparent px-3 py-3 text-sm text-white placeholder:text-slate-500 focus:outline-none"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            data-testid="newsletter-submit"
            className="px-4 bg-brand-cta text-white font-bold text-sm hover:bg-[#D63A00] transition-colors disabled:opacity-60 inline-flex items-center justify-center"
            aria-label="S'inscrire"
          >
            {status === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : <ArrowRight className="w-4 h-4" />}
          </button>
        </div>
      )}
    </form>
  );
}
